import axios from 'axios';
import { disableLoader, enableLoader } from './components/loader/loader';
import { getRToken, getToken, removeToken, setRToken } from './localStorage/';
import { loginAPI, BASE } from './network/routes';
import { login_req, logout_req } from './network/session';
import { notify } from './notifications/notification';
import { store } from './redux';

axios.defaults.withCredentials = true;

/*interceptor request*/
const interceptors = {
  setupInterceptors: () => {
    axios.interceptors.request.use(
      config => {
        if (
          config.method === 'post' ||
          config.method === 'put' ||
          config.method === 'delete' ||
          config.url?.includes('download')
        ) {
          enableLoader();
        }

        const token = getToken();

        if (token && !config.url?.includes(loginAPI.GET_JWT)) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }

        config.headers['Access-Control-Allow-Origin'] = '*';

        // if (config.url?.includes('/administration')) {
        //   config.baseURL = 'https://localhost:5003';
        //   config.url = config.url?.replace('/administration', '');
        // } else if (config.url?.includes('/Institution')) {
        //   config.baseURL = 'https://localhost:5003';
        // } else if (config.url?.includes('/Decision')) {
        //   config.baseURL = 'https://localhost:5003';
        // } else if (config.url?.includes('/Litigii')) {
        //   config.baseURL = 'https://localhost:5003';
        // } else if (config.url?.includes('/LegalDecision')) {
        //   config.baseURL = 'https://localhost:5003';
        // } else if (config.url?.includes('/User')) {
        //   config.baseURL = 'https://localhost:5001';
        // } else if (config.url?.includes('/CcrReport')) {
        //   config.baseURL = 'https://localhost:5003';
        // } else {
        config.baseURL = `${BASE}`;
        // }
        return config;
      },
      error => {
        Promise.reject(error);
      }
    );

    /*interceptor response*/
    axios.interceptors.response.use(
      response => {
        disableLoader();
        return response;
      },
      async error => {
        const { dispatch } = store;
        const originalRequest = error.config;

        disableLoader();
        if (
          error.response &&
          error.response.status === 400 &&
          error.config.url?.includes(loginAPI.GET_JWT)
        ) {
          logout_req(dispatch);
          // window.location.href = 'https://soft.sirar.ro/session/end';
          return;
        }

        if (error.response && error.response.status === 401) {
          localStorage.removeItem('role');
          localStorage.removeItem('id');
          localStorage.removeItem('jwt');
          localStorage.removeItem('rejwt');
          logout_req(dispatch);
          // window.location.href = 'https://soft.sirar.ro/session/end';
        }

        if (
          error.response &&
          error.response.status === 403 &&
          !originalRequest._retry
          // !getToken()
        ) {
          localStorage.removeItem('role');
          localStorage.removeItem('id');
          localStorage.removeItem('jwt');
          localStorage.removeItem('rejwt');
          logout_req(dispatch);
          // window.location.href = 'https://soft.sirar.ro/session/end';
        }

        if (error.response && error.response.status === 409) {
          notify(
            'Se pare ca informatia pe care doriti sa o salvati exista deja in sistem.',
            'error'
          );
          return;
        }

        if (
          error.response &&
          error.response.status === 401 &&
          originalRequest.url === loginAPI.REFRESH
        ) {
          localStorage.removeItem('role');
          localStorage.removeItem('id');
          localStorage.removeItem('jwt');
          localStorage.removeItem('rejwt');
          return Promise.reject(error);
        }

        if (
          error.response &&
          error.response.status !== 403 &&
          error.response.status !== 404 &&
          error.response.status !== 400
        ) {
          notify(
            'A aparut o problema in timpul cererii dumneavoastra. Va rugam incercati din nou, iar daca problema continua contactati-ne.',
            'error'
          );
          return;
        }

        if (
          error.response &&
          error.response.status === 403 &&
          !originalRequest._retry &&
          !!getToken()
        ) {
          const params = new URLSearchParams();
          params.append('client_id', 'sirar');
          params.append('refresh_token', getRToken() as string);
          params.append('grant_type', 'refresh_token');

          return await axios
            .post(loginAPI.GET_JWT, params, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then(response => {
              if (response.status === 200) {
                originalRequest._retry = true;
                removeToken();
                const { id_token } = response.data;

                login_req(dispatch, response.data.id_token);
                setRToken(response.data.refresh_token);

                originalRequest.headers['Authorization'] = 'Bearer ' + id_token;

                return axios(originalRequest);
              }
            });
        } else {
          return Promise.reject(error);
        }
      }
    );
  }
};

export default interceptors;
